export default {
  primary: '#323D77',
  secondary: '#4caf50',
  tertiary: '#495057',
  accent: '#82B1FF',
  error: '#f55a4e',
  info: '#00d3ee',
  success: '#5cb860',
  warning: '#ffa21a',
  general: '#2196F3', // #2196F3
  heron_info: '#c0b5f7',
  heron_success: '#92d685',
  heron_toolbar: '#b1d6fa',
  toolbar_text: '#314680'
}
